import { BannerItem, ArticleItem, ReviewItem } from '../../services/site.model';

export const Banners: BannerItem[] = [
    // {
    //     title: 'Free Pickup & Delivery Service',
    //     text: 'We allow free client car towing service. Makes it easy to place your vehicle in the hands of professionals you can trust, so you can get back on the road with confidence.',
    //     bg: '/assets/slider-3.jpg',
    //     button: 'View Our Services',
    //     url: 'services'
    // } as BannerItem,
    {
        title: 'Professional Auto Collision & Repair',
        text: 'Welcome to Best Auto Body brand new reliable car collision & repair company. We provide the widest range of automotive collision & repair services!',
        bg: '/assets/slider-2.jpg',
        button: 'View Our Services',
        url: 'services'
    } as BannerItem,
    {
        title: 'Professional Auto Repair & Maintenance',
        text: 'Welcome to Best Auto Body brand new reliable car repair company. We provide the widest range of automotive maintenance services!',
        bg: '/assets/slider-1.jpg',
        button: 'View Our Services',
        url: 'services'
    } as BannerItem
];

export const ServicesList: ArticleItem[] = [
    {
        icon: 'icon-building',
        title: 'Free On-Site Estimate',
        subtitle: 'main.We visit a client\'s property or site for estimate'
    } as ArticleItem,
    // {
    //     icon: 'icon-tow-truck',
    //     title: 'Car Pickup',
    //     subtitle: 'We allow free client car tow service if nessessary'
    // } as ArticleItem,
    {
        icon: 'icon-multimeter',
        title: 'Car Diagnostic',
        subtitle: 'Our experts can diagnose your vehicle’s condition right away'
    } as ArticleItem,
    {
        icon: 'icon-car-lift',
        title: 'Collision & Repair',
        subtitle: 'We offer all types of services and repair for your automobiles'
    } as ArticleItem,
    {
        icon: 'icon-pickup',
        title: 'Client Transfer',
        subtitle: 'We allow client transfer service option in case of emergency'
    } as ArticleItem,
];

export const Introduce = [
    {
        icon: 'icon-maintenance',
        title: 'Expert Assessment',
        subtitle: 'The quality of damage assessment is as important as the quality of repairs.Our expert technicians will carefully evaluate the vehicle for both visible and hidden damage to ensure a correct repair project.'
    } as ArticleItem,
    {
        icon: 'icon-winner',
        title: 'Quality Above All',
        subtitle: 'We take pride in all work we perform, which is why we constantly conduct quality inspections at different stages of the repair process, including quality control and quality assurance inspections.'
    } as ArticleItem,
    {
        icon: 'icon-tools',
        title: 'State-of-the-art Repairs',
        subtitle: 'We guarantee you expertise and professionalism. Using state of the art equipment, our highly trained and experienced technicians will conduct auto body repairs to fix the vehicle’s frame, fenders or doors.'
    } as ArticleItem
];

export const Reviews = [
    {
        rate: 5,
        comment: 'Great service. Communicated every step of the way. Because of COVId, parts took a while, but there was clear communication and great value for this service. Would definitely recommend to a friend!',
        name: 'Markus Franklin'
    } as ReviewItem,
    {
        rate: 5,
        comment: 'Best auto body shop ever with excellent service, i highly recommend especially if you want it done right! they really went above and beyond',
        name: 'Robert Bett'
    } as ReviewItem,
    {
        rate: 5,
        comment: 'Any time I have ever had a repair issue with my car, I make sure to take it to these guys. They are top notch professionals who have always come through for me even when the insurance company hasn\'t. Bryan and the rest of the team are the best!',
        name: 'Skyler Rutherford'
    } as ReviewItem,
    {
        rate: 5,
        comment: 'I recently had the back end of my car badly dented and scratched and I received top-notch service from Best Auto Body Shop. Not only did I receive great customer service, they were quick, efficient, detail-oriented and very fairly priced. I couldn\'t even tell any damage was done once I got my car back. I HIGHLY recommend Best Auto Body Shop!',
        name: 'Susan Han'
    } as ReviewItem,
    {
        rate: 5,
        comment: 'For several years I have been a very satisfied customer of Best Auto Body.  My repair last week was done with the same excellent result as in the past.  Manager Bryan Garay, Alex, Nixon, and the rest of the team go the extra mile to assure customer satisfaction.  The friends whom I have referred to Best Auto Body have also been very satisfied.  Keep up the good work!',
        name: 'Judith Henderson'
    } as ReviewItem,
    {
        rate: 5,
        comment: 'I love this place! They are always really nice and the prices for their services are awesome! Also, I\'ve never waited all that long there. I got two times car accident in one month, Now my Lexus IS 250 working great! and Driving awesome! If you need repair your car, Please call to Best Auto Body and go to the Best Auto Body Shop.',
        name: 'James Sim'
    } as ReviewItem,
    {
        rate: 5,
        comment: 'This stellar body shop deserves the 5 stars it has in Google right now. Thoughtful, diligent mechanics. Quick turnaround. And inexpensively priced for Alexandria...a couple times less expensive than other options I looked into. The team resolved a water leak in the cabin of our Ford Focus I\'ve been fighting for 2 years. I\'m a big fan of Best Auto. Been there three times for work and it\'s my go-to place for body work.',
        name: 'Jonathan Matias'
    } as ReviewItem,
    {
        rate: 5,
        comment: 'These guys have done multiple jobs for me. I must say they are the best. The vehicle will look identical to the original. It’s very hard to find great customer service and labor in the same place. They have both! I recommend their service.',
        name: 'Mario Dean'
    } as ReviewItem,
    {
        rate: 5,
        comment: 'Got into an accident and the entire front end of my vehicle was totaled. My insurance provided options for body shops but read some reviews online and decided to give these guys a chance and I’m glad I did. My RAV4 looks better than new! Not only that they really went the extra mile in customer service. Each time I called, someone was on the other line rather than having to be put on hold and was able to address all my questions and concerns',
        name: 'D Y'
    } as ReviewItem,
    {
        rate: 4,
        comment: 'Place was clean well staff and the job was done on a understandable time frame.',
        name: 'Jose Fabian'
    } as ReviewItem
];
